import { render } from "./management.cattle.io.user.vue?vue&type=template&id=5a0a577a&scoped=true"
import script from "./management.cattle.io.user.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.user.vue?vue&type=script&lang=js"

import "./management.cattle.io.user.vue?vue&type=style&index=0&id=5a0a577a&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0a577a"]])

export default __exports__